export const GET_BA_DATA = "GET_BA_DATA";
export const GET_BA_DATA_INVOICE = "GET_BA_DATA_INVOICE";
export const LATE_FEE = "LATE_FEE";
export const GET_BA_DATA_INVOICE_BY_SITE = "GET_BA_DATA_INVOICE_BY_SITE";
export const GET_CLIENT_ORDERS = "GET_CLIENT_ORDERS";
